import React from 'react';
import { Link } from 'react-router-dom';
import './Menu.css';


const Menu = () => {
    return (
        <header className="p-4 dark:bg-gray-800 dark:text-gray-100">
            <div className="container flex justify-between h-16 mx-auto">
                <Link rel="noopener noreferrer" to="/home" aria-label="Back to homepage" className="flex items-center p-2">
                    <h1 className='text-3xl font-bold'>Pro Quiz Context</h1>
                </Link>
                <ul className="items-stretch space-x-3 lg:flex">
                    <li className="flex">
                        <Link rel="noopener noreferrer" to="/home" className="flex items-center px-4 -mb-1 border-b-2 dark:border-transparent dark:text-purple-400 dark:border-purple-400">Home</Link>
                    </li>
                    <li className="flex">
                        <Link rel="noopener noreferrer" to="/about" className="flex items-center px-4 -mb-1 border-b-2 dark:border-transparent">About</Link>
                    </li>
                    <li className="flex">
                        <Link rel="noopener noreferrer" to="/statics" className="flex items-center px-4 -mb-1 border-b-2 dark:border-transparent">Statics</Link>
                    </li>
                    <li className="flex">
                        <Link rel="noopener noreferrer" to="/blog" className="flex items-center px-4 -mb-1 border-b-2 dark:border-transparent">Blog</Link>
                    </li>
                </ul>
            </div>
        </header>
    );
};

export default Menu;